function stripTrailingApi(url: string): string {
  return url.trim().replace(/\/+$/, "").replace(/\/api$/i, "");
}

export function getApiOrigin(): string {
  const env =
    process.env.REACT_APP_API_ORIGIN ||
    process.env.PUBLIC_BACKEND_HOST ||
    process.env.REACT_APP_API_HOST ||
    process.env.REACT_APP_API_BASE_URL ||
    process.env.REACT_APP_API_BASEURL ||
    "";

  if (env) return stripTrailingApi(env);
  if (typeof window !== "undefined" && window.location.origin) {
    return stripTrailingApi(window.location.origin);
  }
  return "http://localhost:5259";
}
